import { useMemo } from 'react';
import { create } from 'zustand';
import { guidanceConfigIndexArray } from '../config/index';

const USER_GUIDANCE_UNION_CODE = 'USER_GUIDANCE_UNION_CODE';
let guidanceEnable = false;

let shownGuidanceEntryPrompt = false;

function initCloudData() {
  const guidanceRecord = localStorage.getItem(USER_GUIDANCE_UNION_CODE);
  if (guidanceRecord && Boolean(guidanceRecord)) {
    guidanceEnable = false;
  }
}

initCloudData();

/**
 * 控制引导索引位置
 */
const useGuidanceState = create((set) => ({
  currentPositionIndex: 0,

  guidanceEntryVisible: false,

  setGuidanceEntryVisible: (visible) =>
    set({
      guidanceEntryVisible: visible,
    }),

  increaseIndex: (timeout = 500) => {
    setTimeout(() => {
      set((state) => {
        const newIndex = state.currentPositionIndex + 1;

        let guidanceEntryVisible = false;
        // 结束点, 正常结束
        if (newIndex === guidanceConfigIndexArray.length - 1 && guidanceEnable) {
          localStorage.setItem(USER_GUIDANCE_UNION_CODE, true);
          guidanceEnable = false;
          guidanceEntryVisible = true;
        }

        return {
          currentPositionIndex: newIndex,
          guidanceEntryVisible,
        };
      });
    }, timeout);
  },

  decreaseIndex: (timeout = 500) => {
    setTimeout(() => {
      set((state) => ({
        currentPositionIndex: state.currentPositionIndex - 1,
      }));
    }, timeout);
  },

  skipToTarget: (targetIndex) => {
    setTimeout(() => {
      set(() => {
        const isSkip = targetIndex > guidanceConfigIndexArray.length;
        // const isSkip = true;
        // 结束点，跳过结束
        if (isSkip) {
          localStorage.setItem(USER_GUIDANCE_UNION_CODE, true);
          guidanceEnable = false;

          setTimeout(() => {
            // 控制只展示一次提示入口
            shownGuidanceEntryPrompt = true;
          }, 3000);
        } else if (targetIndex === 0) {
          // 重启的逻辑
          guidanceEnable = true;
        }

        return {
          currentPositionIndex: targetIndex,
          guidanceEntryVisible: isSkip && !shownGuidanceEntryPrompt,
        };
      });
    }, 500);
  },
}));

/**
 * 控制某一个popover的显示状态
 * @param {*} index
 */
export const useGuidanceHooks = (sequenceArray) => {
  const { currentPositionIndex, increaseIndex, decreaseIndex, skipToTarget } = useGuidanceState();

  const sequenceIndexArray = useMemo(() => {
    return guidanceConfigIndexArray.filter((item) => sequenceArray.includes(item.alias)).map((item) => item.index);
  }, [sequenceArray]);

  const visible = useMemo(() => {
    return sequenceIndexArray.includes(currentPositionIndex) && guidanceEnable;
  }, [currentPositionIndex, sequenceIndexArray]);

  const outstandingStyle = useMemo(() => {
    if (visible) {
      return 'relative z-[72]';
    } else {
      return '';
    }
  }, [visible]);

  return {
    visible,
    nextGuidance: increaseIndex,
    preGuidance: decreaseIndex,
    skipToTarget,
    outstandingStyle,
  };
};

/**
 * 提供包含跳过、入口指引、重启引导的能力
 */
export const useGuidanceRestartHooks = () => {
  const { skipToTarget, guidanceEntryVisible, setGuidanceEntryVisible } = useGuidanceState();

  return {
    skipGuidance: () => {
      skipToTarget(guidanceConfigIndexArray.length + 1);
    },
    guidanceEntryVisible,
    closeGuidanceEntry: () => {
      setGuidanceEntryVisible(false);
    },
    restartGuidance: () => {
      skipToTarget(0);
    },
  };
};
